module.exports = __webpack_public_path__ + "media/images/iron-bg-wrp-674f24061ec6f4c9d524c63535074af0.jpg";